import React, { useMemo } from "react";
import { cn } from "./utils";
import { Spinner } from "./Spinner";

const Stamp = ({ grade, title, size = "md", ...props }) => {
  const rotation = useMemo(
    () => (props.noRotate ? 0 : `${Math.floor(Math.random() * 29) - 14}deg`),
    [props.noRotate]
  );

  if (!grade)
    return <Spinner className={cn("text-gray-700", props.className)} />;

  const sizeClasses = {
    sm: "text-xl px-2 py-0.5",
    md: "text-3xl px-4 py-1",
    lg: "text-5xl px-6 py-2",
  };

  const titleSizeClasses = {
    sm: "text-[0.5rem]",
    md: "text-xs",
    lg: "text-sm",
  };

  let stampClasses = cn(
    "whitespace-nowrap transform text-gray-700 font-bold border-2 border-gray-700 inline-block uppercase rounded-lg font-mono mix-blend-multiply",
    sizeClasses[size]
  );

  let maskStyles = {
    WebkitMaskImage:
      "url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/8399/grunge.png')",
    WebkitMaskSize: "944px 604px",
  };

  switch (grade) {
    case "F":
      stampClasses = cn(
        "transform text-red-600 font-bold border-4 border-red-600 inline-block uppercase rounded-lg font-mono mix-blend-multiply",
        sizeClasses[size]
      );
      maskStyles.WebkitMaskPosition = "2rem 3rem";
      break;
    case "D":
      stampClasses = cn(
        "transform text-gray-400 font-bold border-4 border-gray-400 inline-block uppercase font-sans mix-blend-multiply rounded-none",
        sizeClasses[size]
      );
      maskStyles.WebkitMaskPosition = "0rem 0rem";
      break;
    case "C":
      stampClasses = cn(
        "transform text-yellow-400 font-bold border-4 border-yellow-400 inline-block uppercase font-mono mix-blend-multiply rounded-full",
        sizeClasses[size]
      );
      maskStyles.WebkitMaskPosition = "8rem 1rem";
      break;
    case "B":
      stampClasses = cn(
        "transform text-gray-600 font-semibold border-4 border-gray-600 inline-block uppercase font-mono mix-blend-multiply rounded-none",
        sizeClasses[size]
      );
      maskStyles.WebkitMaskPosition = "12rem 0rem";
      break;
    case "A":
      stampClasses = cn(
        "transform text-green-700 font-bold border-4 border-green-700 inline-block uppercase font-mono mix-blend-multiply rounded-none",
        sizeClasses[size]
      );
      maskStyles.WebkitMaskPosition = "13rem 6rem";
      break;
    case "A+":
      stampClasses = cn(
        "transform text-green-800 font-bold border-4 border-green-800 inline-block uppercase font-mono mix-blend-multiply rounded-none",
        sizeClasses[size]
      );
      maskStyles.WebkitMaskPosition = "1rem 5rem";
      break;
    default:
      break;
  }

  return (
    <span
      className={cn(stampClasses, props.className)}
      style={{ ...maskStyles, transform: `rotate(${rotation})` }}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      {grade}
      {title && (
        <span className={cn("ml-2 whitespace-nowrap text-gray-500", titleSizeClasses[size])}>
          {title}
        </span>
      )}
    </span>
  );
};

export default Stamp;
